<template>
    <div class="foot">
        <el-row class="nextline">
            <el-col :xs="0" :md="6" :lg="6" :xl="6">
                &nbsp;
            </el-col>
            <el-col :xs="24" :md="12" :lg="12" :xl="12">
                <div class="div1">
                    <div class="input">
                        <div>
                            <input placeholder="提交" type="text">
                        </div>
                        <span>SUBMIT</span>
                    </div>
                    <div class="link">
                        <span>关于我们<p></p></span>|
                        <span>媒体报道<p></p></span>|
                        <span>职位招聘<p></p></span>|
                        <span>联系我们<p></p></span>|
                        <span>服务项目<p></p></span>
                    </div>
                </div>                
            </el-col>
            <el-col :xs="0" :md="6" :lg="6" :xl="6">
                 &nbsp;
            </el-col>
        </el-row>
        <el-row>
            <el-col :xs="0" :sm="6" :md="6" :lg="6" :xl="6">
                &nbsp;
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div class="div2">
                    <span>Copyright ©2015-2024 zksino.com All Rights Reserved.中凯顺版权所有 </span>|
                    <!-- <span>法律</span>|
                    <span>隐私</span>|
                    <span>定位</span>| -->
                    <span @click="linkto('https://beian.miit.gov.cn/')">粤ICP备19086725号-1</span>
                </div>              
            </el-col>
            <el-col :xs="0" :sm="6" :md="6" :lg="6" :xl="6">
                 &nbsp;
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    data () {
        return {

        }
    },
    methods:{
        linkto(url) {
            window.open(url)
        }
    }
}
</script>
<style lang="less" scoped>
.foot{
    background-image: url("../assets/images/footer_bg.png");
    width: 100%;
    background-size: cover;
    padding-bottom: 20px;
    .div1{
        padding: 20px;
        text-align: center;
        border-bottom: 1px solid rgb(104, 101, 101);
        .link{
            margin-top: 40px;
            color: rgb(236, 91, 33);
            text-align: center;
            &::after{
                content: ""; 
                display: inline-block; 
                overflow: hidden; 
                width: 100%;
            }
            span{
                display: inline-block;
                text-align: center;
                margin: 0 22px;
                color: #fff;
                cursor: pointer;
                text-align: center;
                p{
                    border-bottom: 1px solid rgb(236, 85, 25);
                    width: 0;
                    margin: 0 auto;
                    transition: all .3s ease;
                }
                &:hover{
                    p{
                        width: 60px;
                    }
                }  
            }
        }
        .input{
            div{
                display: inline-block;
                background-color: #fff;
                padding: 10px;
                line-height: 30px;
                margin-top: 40px;
            }
            input{
                outline: none;
                background: none;
                border: none;
                font-size: 20px;
                line-height: 30px;
            }
            span{
                display: inline-block;
                line-height: 40px;
                background-color: rgb(231, 88, 31);
                border-radius: 5px;
                color: #fff;
                padding: 8px 20px;
                margin:10px 10px;
                cursor: pointer;
                transition: background-color .3s ease;
                &:hover{
                    background-color: rgb(218, 120, 81);
                }
            }
        }
    }
    .nextline{
        border-bottom: 1px solid rgb(104, 101, 101);
    }
    .div2{
        text-align: center;
        color: #fff;
        margin-top: 30px;
        span{
            margin: 20px;
            transition: color .3s ease;
            cursor: pointer;
            &:hover{
                color: rgb(230, 85, 28);
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Foot.vue